import { Navigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStoreByName } from '../../../hooks/use-stores.hooks';
import { ROLES } from '@shared/types';

const AdminDefaultRedirect = observer(() => {
  const userStore = useStoreByName('userStore');
  const roleId = userStore.userData?.personalInfo?.role?.id;

  if (roleId === ROLES.PRINCIPAL) {
    return <Navigate to="/admin-panel/principal-dashboard" replace />;
  }

  return <Navigate to="/admin-panel/overview" replace />;
});

export default AdminDefaultRedirect;
